export default __webpack_public_path__ + "pdf/Charlie_Sheehan.a3d3870.pdf";